export const DISPLAY_AS = {
  COUNT: { label: 'Count', value: 'count' },
  PERCENT: { label: 'Percentages', value: 'pct' },
};

export const DISPLAY_AS_OPTIONS = [DISPLAY_AS.PERCENT, DISPLAY_AS.COUNT];

export const getConceptImagesForQuestion = ({ question, quotaGroupConceptImages = [] }) => {
  if (question?.concepts?.length > 0) {
    const filteredConcepts = question.concepts
      .filter((c) => c.image?.cdnUrl)
      .map((concept) => ({
        alt: concept.name?.trim() || 'Concept',
        caption: concept.name?.trim() || 'Concept',
        id: concept.id,
        name: concept.name?.trim() || 'Concept',
        src: concept.image.cdnUrl,
      }));
    if (filteredConcepts.length > 0) {
      return filteredConcepts;
    }
  }
  if (question?.showConceptImage && quotaGroupConceptImages.length > 0) {
    return quotaGroupConceptImages;
  }
  return [];
};

export const sanitizeQuestionText = (text) => {
  if (!text || typeof text !== 'string') return text;
  return text
    .replace(/<[^>]*>/g, ' ')
    .replace(/\s*\[concept_image\]\s*/gi, ' ')
    .replace(/&nbsp;/gi, ' ')
    .replace(/\s+/g, ' ')
    .trim();
};
